import { render, staticRenderFns } from "./SplitShipment.vue?vue&type=template&id=21f23d36&"
import script from "./SplitShipment.vue?vue&type=script&lang=js&"
export * from "./SplitShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports